// 'use client'

// import Link from 'next/link'
// import { useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { handleLogout } from '../../lib/handleLogout'
// import LoginSignup from '../auth/LoginSignup'
// import { useRouter } from 'next/navigation'
// import { getUserId } from '../../lib/GetBaseUrl'
// import { checkTokenAuthentication } from '../../lib/checkTokenAuthentication'
// import ShopAllPage from '../ShopAllPage'
// import { useMediaQuery } from 'react-responsive'

// const MyAccount = ({ user, isloaded, inline = false }) => {
//   const dispatch = useDispatch()
//   const [modal, setModal] = useState(false)
//   const [showMenubar, SetShowMenubar] = useState(false)
//   const [isActive, setIsActive] = useState('')
//   const [isShopAllOpenMenu, setIsShopAllOpenMenu] = useState(false)
//   const [isServiceOpenMenu, setIsServiceOpenMenu] = useState(false)
//   const router = useRouter()
//   const userIdCookie = getUserId()

//   const malePic = 'https://cdn-icons-png.flaticon.com/512/2922/2922510.png'

//   const femalePic = '/images/female.png'

//   const neutralPic = 'https://cdn-icons-png.flaticon.com/512/2922/2922510.png'

//   // Selector for cartCount from Redux store (based on 'old code' usage, though not used in the new code's list items)
//   // const { cartCount } = useSelector((state) => state?.cart)

//   const setShowModal = () => {
//     setModal(true)
//     SetShowMenubar(false)
//   }

//   const closeModal = () => {
//     setModal(false)
//   }

//   const menuOpen = () => {
//     SetShowMenubar(true)
//   }

//   const closeMenu = () => {
//     SetShowMenubar(false)
//   }

//   const checkModal = () => {
//     SetShowMenubar(false)
//     if (!user?.userId) {
//       if (userIdCookie) {
//         checkTokenAuthentication(dispatch)
//       } else {
//         setModal(true)
//       }
//     }
//   }

//   // Check for mobile view for responsive behavior
//   const isMobile = useMediaQuery({
//     query: '(max-width: 768px)'
//   })

//   // Function to close all menus/modals and reset body overflow
//   const closeAllMenus = () => {
//     document.body.style.overflow = 'auto'
//     closeMenu()
//     setIsShopAllOpenMenu(false)
//     setIsServiceOpenMenu(false)
//   }

//   // Handler for logout (combines `handleLogout` from local utility and social logout if needed)
//   const handleUserLogout = (e) => {
//     // Prevent default form submission behavior if this were part of a form
//     if (e) e.preventDefault()

//     // Reset body overflow before logging out
//     document.body.style.overflow = 'auto'

//     // Call external logout functions
//     handleLogout(router, dispatch)
//     closeMenu()

//     // NOTE: The new code *removed* the `handleSocialLogout` function and its call.
//     // If using next-auth, you may need to re-introduce `signOut` logic here
//     // if a simple redirect/state clear isn't enough.
//     // E.g., `signOut({ redirect: false })`
//   }

//   return (
//     <>
//       {/* Modal for Login/Signup */}
//       {modal && <LoginSignup onClose={closeModal} />}

//       {/* Shop All Menu */}
//       {isActive === 'shop-all' && isShopAllOpenMenu && (
//         <ShopAllPage setIsActive={setIsActive} isActive={isActive} />
//       )}

//       {/* Services Menu (currently commented out in new code logic) */}
//       {/* {isActive === 'services' && isServiceOpenMenu && (
//         <ServicesPage
//           title="Services"
//           setIsActive={setIsActive}
//           isActive={isActive}
//         />
//       )} */}

//       <div className="flex items-center">
//         <ul
//           className={`my-account-wrapper ${inline ? '' : 'max-sm:fixed max-sm:inset-x-0 max-sm:bottom-0 max-sm:bg-white max-sm:shadow-[0px_1px_7px_0px_#B3B3B380] max-sm:justify-around! max-sm:px-4 max-sm:py-2.5 max-sm:z-11'}`}
//         >
//           {/* Shop All Item (Mobile/Desktop) */}
//           {/* <li className="my-account-item group">
//             <button
//               className="my-account-link"
//               onClick={() => {
//                 setIsActive('shop-all')
//                 document.body.style.overflow = 'hidden'
//                 setIsShopAllOpenMenu(true)
//                 setIsServiceOpenMenu(false)
//                 closeMenu()
//               }}
//             >
//               <i
//                 className={`m-icon shop-all-icon group-hover:bg-primary ${
//                   isActive === 'shop-all' && isShopAllOpenMenu
//                     ? 'bg-[#0073cf]!'
//                     : ''
//                 }`}
//               ></i>
//               <p
//                 className={`my-account-name group-hover:text-primary !leading-normal ${
//                   isActive === 'shop-all' && isShopAllOpenMenu
//                     ? 'text-[#0073cf]!'
//                     : ''
//                 }`}
//               >
//                 Shop All
//               </p>
//             </button>
//           </li> */}

//           {/* Services Item (Mobile/Desktop) */}
//           {/* <li className="my-account-item group">
//             <button
//               className="my-account-link"
//               onClick={() => {
//                 setIsActive('services')
//                 document.body.style.overflow = 'hidden'
//                 setIsServiceOpenMenu(true)
//                 setIsShopAllOpenMenu(false)
//                 closeMenu()
//               }}
//             >
//               <i
//                 className={`m-icon services-icon group-hover:bg-primary ${
//                   isActive === 'services' && isServiceOpenMenu
//                     ? 'bg-[#0073cf]!'
//                     : ''
//                 }`}
//               ></i>
//               <p
//                 className={`my-account-name group-hover:text-primary ${
//                   isActive === 'services' && isServiceOpenMenu
//                     ? 'text-[#0073cf]!'
//                     : ''
//                 }`}
//               >
//                 Services
//               </p>
//             </button>
//           </li> */}
//           {/* <li className="my-account-item">
//             <Link
//               href={isloaded && user?.userId ? '/user/wishlist' : ''}
//               className="my-account-link"
//               onClick={checkModal}
//             >
//               <i className="m-icon wishlist-icon"></i>
//               <p className="my-account-name">Wishlist</p>
//             </Link>
//           </li> */}
//           {/* Profile / Log In Item (Hover for Desktop, Click for Mobile) */}
//           <li
//             className={`my-account-item group ${showMenubar ? ' active' : ''}`}
//             onMouseEnter={() => {
//               if (!isMobile) {
//                 menuOpen()
//                 setIsShopAllOpenMenu(false)
//                 setIsServiceOpenMenu(false)
//                 // Note: Desktop hover opens menu, but intentionally *doesn't* set overflow: hidden based on original logic
//               }
//             }}
//             onMouseLeave={() => {
//               if (!isMobile) {
//                 closeMenu()
//                 // document.body.style.overflow = 'auto'
//               }
//             }}
//             onClick={isMobile ? menuOpen : undefined} // Only trigger menuOpen on click for mobile
//           >
//             <button
//               className="my-account-link"
//               onClick={() => {
//                 if (isMobile) {
//                   // For mobile, click opens menu AND checks auth/modal
//                   menuOpen()
//                   document.body.style.overflow = 'hidden'
//                   if (!user?.userId) {
//                     checkModal()
//                   }
//                 } else {
//                   // For desktop, click checks auth/modal
//                   checkModal()
//                 }
//                 setIsShopAllOpenMenu(false)
//                 setIsServiceOpenMenu(false)
//               }}
//             >
//               {
//                 isloaded && !user?.userId ? (
//                   // <i
//                   //   className={
//                   //     'm-icon profile-icon group-hover:bg-primary !w-5 !h-5'
//                   //   }
//                   // ></i>
//                   <button className="px-4 py-1.5 text-sm sm:px-6 sm:py-2 sm:text-base md:px-8 md:py-2 md:text-base rounded-lg border border-primary text-primary font-semibold bg-[#FFFBF2] hover:bg-primary hover:text-white transition-colors whitespace-nowrap">
//                     LOGIN
//                   </button>
//                 ) : (
//                   // <img
//                   //   src={user?.profileImage}
//                   //   alt={user?.fullName}
//                   //   className="h-6 rounded-full"
//                   // />
//                   <i
//                     className={
//                       'm-icon profile-icon group-hover:bg-primary !w-5 !h-5'
//                     }
//                   ></i>
//                 )
//                 //   : user?.gender?.toLowerCase() === 'male' ? (
//                 //     <img
//                 //       src={malePic}
//                 //       alt={user?.fullName}
//                 //       className="h-6 rounded-full"
//                 //     />
//                 //   ) : user?.gender?.toLowerCase() === 'female' ? (
//                 //     <img
//                 //       src={femalePic}
//                 //       alt={user?.fullName}
//                 //       className="h-6 rounded-full"
//                 //     />
//                 //   ) : (
//                 //     <img
//                 //       src={neutralPic}
//                 //       alt={user?.fullName}
//                 //       className="h-6 rounded-full"
//                 //     />
//                 //   )
//               }
//               {/* <p className="my-account-name group-hover:text-primary leading-normal">
//                 {isloaded && user?.userId
//                   ? user?.fullName?.split(' ')[0]
//                   : 'Log In'}
//               </p> */}
//             </button>

//             {/* Dropdown Menu (Only shown when logged in on desktop/mobile menu open) */}
//             {user?.userId && (
//               //   <div className="my-account-profile-details-wrapper">
//               <div
//                 className={`my-account-profile-details-wrapper ${
//                   showMenubar ? '' : 'hidden!'
//                 }`}
//               >
//                 {/* Welcome Section */}
//                 <ul className="my-account-profile-details-item">
//                   <li className="my-account-profile-login-wrapper">
//                     <div className="my-account-profile-before-login">
//                       <p className="my-account-profile-titel text-primary text-14 font-semibold not-last:mb-2 capitalize">
//                         Welcome
//                       </p>
//                       <p className="my-account-profile-titel text-primary text-14 font-semibold not-last:mb-2 capitalize">
//                         {user?.fullName}
//                       </p>
//                     </div>
//                   </li>
//                 </ul>
//                 <hr className="border border-b w-full mb-4 border-[#DBDBDB]" />

//                 {/* Core Links */}
//                 <ul
//                   className={`my-account-profile-details-item ${
//                     user?.userId && 'mb-4'
//                   }`}
//                 >
//                   <li className="my-account-profile-details-list not-last:mb-3">
//                     <Link
//                       href="/user/profile"
//                       className="my-account-profile-link gap-2 data-flex-item-center"
//                       onClick={() => {
//                         checkModal()
//                         if (isMobile) {
//                           document.body.style.overflow = 'auto'
//                           closeAllMenus()
//                         }
//                       }}
//                     >
//                       <i className="m-icon profile-icon w-5! h-5!"></i>
//                       <span>My Profile</span>
//                     </Link>
//                   </li>
//                   {isloaded && user?.userId && (
//                     <li className="my-account-profile-details-list not-last:mb-3">
//                       <Link
//                         href="/user/orders"
//                         className="my-account-profile-link gap-2 data-flex-item-center"
//                         onClick={() => {
//                           checkModal()
//                           if (isMobile) {
//                             // document.body.style.overflow = 'auto'
//                             closeAllMenus()
//                           }
//                         }}
//                       >
//                         <i className="m-icon header_order_icon w-5! h-5!"></i>{' '}
//                         <span>Orders</span>
//                       </Link>
//                     </li>
//                   )}
//                   {/* <li className="my-account-profile-details-list not-last:mb-3">
//                     <Link
//                       href={'/user/wishlist'}
//                       className="my-account-profile-link gap-2 data-flex-item-center"
//                       onClick={closeAllMenus}
//                     >
//                       <i className="m-icon header_whishlist_icon w-5! h-5!"></i>
//                       <span>Wishlist</span>
//                     </Link>
//                   </li> */}
//                   <li className="my-account-profile-details-list not-last:mb-3">
//                     <Link
//                       href="/contact-us"
//                       className="my-account-profile-link"
//                       onClick={closeAllMenus}
//                     >
//                       <i className="m-icon header_contact_icon w-5! h-5!"></i>
//                       <span>Contact Us </span>
//                     </Link>
//                   </li>
//                 </ul>

//                 <hr className="border border-b w-full mb-4 border-[#DBDBDB]" />

//                 {/* Additional Links & Mobile-Specific Links */}
//                 <ul className="my-account-profile-details-item mb-4">
//                   {isMobile && (
//                     <>
//                       <li className="my-account-profile-details-list not-last:mb-3">
//                         <Link
//                           href={'/user/review'}
//                           className="my-account-profile-link gap-2 data-flex-item-center"
//                           onClick={closeAllMenus}
//                         >
//                           <i className="m-icon new-rating-empty-icon w-4 h-4 bg-black"></i>
//                           <span>Review</span>
//                         </Link>
//                       </li>
//                     </>
//                   )}
//                   <li className="my-account-profile-details-list not-last:mb-3">
//                     <Link
//                       href={isloaded && user?.userId ? '/user/coupon' : '#'}
//                       className="my-account-profile-link gap-2 data-flex-item-center"
//                       onClick={closeAllMenus}
//                     >
//                       <i className="m-icon header_coupons_icon w-5! h-5!"></i>
//                       <span>Coupons</span>
//                     </Link>
//                   </li>
//                   <li className="my-account-profile-details-list not-last:mb-3">
//                     <Link
//                       href={isloaded && user?.userId ? '/user/address' : '#.'}
//                       className="my-account-profile-link"
//                       onClick={closeAllMenus}
//                     >
//                       <i className="m-icon w-5! h-5! header_address_icon"></i>
//                       <span>Saved Addresses</span>
//                     </Link>
//                   </li>
//                 </ul>

//                 <hr className="border border-b w-full mb-4 border-[#DBDBDB]" />

//                 {/* Logout Button */}
//                 <ul className="my-account-profile-details-item">
//                   <li className="my-account-profile-details-list not-last:mb-3">
//                     <button
//                       onClick={handleUserLogout}
//                       className="my-account-profile-link w-full"
//                     >
//                       <i className="m-icon w-5! h-5! logout_icon"></i>
//                       Logout
//                     </button>
//                   </li>
//                 </ul>
//               </div>
//             )}
//           </li>

//           {/* Mobile Overlay (tap outside to close) */}
//           {isMobile && showMenubar && user?.userId && (
//             <>
//               <div
//                 className="fixed inset-0 bg-black/50 z-10"
//                 onClick={closeAllMenus}
//               ></div>

//               {/* Close Button */}
//               <button
//                 className="fixed right-4 sm:right-15 max-md:top-14 max-sm:top-24 top-44 z-11 flex items-center justify-center p-1 active:bg-[#EAEAEF] sm:hover:bg-[#EAEAEF] rounded-sm"
//                 onClick={closeAllMenus}
//               >
//                 <i className="m-icon close-icon"></i>
//               </button>
//             </>
//           )}
//         </ul>
//       </div>
//     </>
//   )
// }

// export default MyAccount


'use client'

import Link from 'next/link'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { handleLogout } from '../../lib/handleLogout'
import LoginSignup from '../auth/LoginSignup'
import { useRouter } from 'next/navigation'
import { getUserId } from '../../lib/GetBaseUrl'
import { checkTokenAuthentication } from '../../lib/checkTokenAuthentication'
import ShopAllPage from '../ShopAllPage'
import { useMediaQuery } from 'react-responsive'

const MyAccount = ({ user, isloaded, inline = false }) => {
  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)
  const [showMenubar, SetShowMenubar] = useState(false)
  const [isActive, setIsActive] = useState('')
  const [isShopAllOpenMenu, setIsShopAllOpenMenu] = useState(false)
  const [isServiceOpenMenu, setIsServiceOpenMenu] = useState(false)
  const router = useRouter()
  const userIdCookie = getUserId()

  const malePic = 'https://cdn-icons-png.flaticon.com/512/2922/2922510.png'

  const femalePic = '/images/female.png'

  const neutralPic = 'https://cdn-icons-png.flaticon.com/512/2922/2922510.png'

  // Selector for cartCount from Redux store (based on 'old code' usage, though not used in the new code's list items)
  // const { cartCount } = useSelector((state) => state?.cart)

  const setShowModal = () => {
    setModal(true)
    SetShowMenubar(false)
  }

  const closeModal = () => {
    setModal(false)
  }

  const menuOpen = () => {
    SetShowMenubar(true)
  }

  const closeMenu = () => {
    SetShowMenubar(false)
  }

  const checkModal = () => {
    SetShowMenubar(false)
    if (!user?.userId) {
      if (userIdCookie) {
        checkTokenAuthentication(dispatch)
      } else {
        setModal(true)
      }
    }
  }

  // Check for mobile view for responsive behavior
  const isMobile = useMediaQuery({
    query: '(max-width: 768px)'
  })

  // Function to close all menus/modals and reset body overflow
  const closeAllMenus = () => {
    document.body.style.overflow = 'auto'
    closeMenu()
    setIsShopAllOpenMenu(false)
    setIsServiceOpenMenu(false)
  }

  // Handler for logout (combines `handleLogout` from local utility and social logout if needed)
  const handleUserLogout = (e) => {
    // Prevent default form submission behavior if this were part of a form
    if (e) e.preventDefault()

    // Reset body overflow before logging out
    document.body.style.overflow = 'auto'

    // Call external logout functions
    handleLogout(router, dispatch)
    closeMenu()

    // NOTE: The new code *removed* the `handleSocialLogout` function and its call.
    // If using next-auth, you may need to re-introduce `signOut` logic here
    // if a simple redirect/state clear isn't enough.
    // E.g., `signOut({ redirect: false })`
  }

  return (
    <>
      {/* Modal for Login/Signup */}
      {modal && <LoginSignup onClose={closeModal} />}

      {/* Shop All Menu */}
      {isActive === 'shop-all' && isShopAllOpenMenu && (
        <ShopAllPage setIsActive={setIsActive} isActive={isActive} />
      )}

      {/* Services Menu (currently commented out in new code logic) */}
      {/* {isActive === 'services' && isServiceOpenMenu && (
        <ServicesPage
          title="Services"
          setIsActive={setIsActive}
          isActive={isActive}
        />
      )} */}

      <div className="flex items-center">
        <ul
          className={`my-account-wrapper ${inline ? '' : 'max-sm:fixed max-sm:inset-x-0 max-sm:bottom-0 max-sm:bg-white max-sm:shadow-[0px_1px_7px_0px_#B3B3B380] max-sm:justify-around! max-sm:px-4 max-sm:py-2.5 max-sm:z-11'}`}
        >
          {/* Profile / Log In Item (Hover for Desktop, Click for Mobile) */}
          <li
            className={`my-account-item group ${showMenubar ? ' active' : ''}`}
            onMouseEnter={() => {
              if (!isMobile) {
                menuOpen()
                setIsShopAllOpenMenu(false)
                setIsServiceOpenMenu(false)
              }
            }}
            onMouseLeave={() => {
              if (!isMobile) {
                closeMenu()
              }
            }}
            onClick={isMobile ? menuOpen : undefined} // Only trigger menuOpen on click for mobile
          >
            <button
              className="my-account-link"
              onClick={() => {
                if (isMobile) {
                  // For mobile, click opens menu AND checks auth/modal
                  menuOpen()
                  document.body.style.overflow = 'hidden'
                  if (!user?.userId) {
                    checkModal()
                  }
                } else {
                  // For desktop, click checks auth/modal
                  checkModal()
                }
                setIsShopAllOpenMenu(false)
                setIsServiceOpenMenu(false)
              }}
            >
              {isloaded && !user?.userId ? (
                <button className="px-4 py-1.5 text-sm sm:px-6 sm:py-2 sm:text-base md:px-8 md:py-2 md:text-base rounded-lg border border-primary text-primary font-semibold bg-[#FFFBF2] hover:bg-primary hover:text-white transition-colors whitespace-nowrap">
                  LOGIN
                </button>
              ) : (
                <i
                  className={
                    'm-icon profile-icon group-hover:bg-primary !w-5 !h-5'
                  }
                ></i>
              )}
            </button>

            {/* Dropdown Menu (Only shown when logged in on desktop/mobile menu open) */}
            {user?.userId && (
              <div
                className={`my-account-profile-details-wrapper ${
                  showMenubar ? '' : 'hidden!'
                }`}
              >
                {/* Welcome Section */}
                <ul className="my-account-profile-details-item">
                  <li className="my-account-profile-login-wrapper">
                    <div className="my-account-profile-before-login">
                      <p className="my-account-profile-titel text-primary text-14 font-semibold not-last:mb-2 capitalize">
                        Welcome
                      </p>
                      <p className="my-account-profile-titel text-primary text-14 font-semibold not-last:mb-2 capitalize">
                        {user?.fullName}
                      </p>
                    </div>
                  </li>
                </ul>
                <hr className="border border-b w-full mb-4 border-[#DBDBDB]" />

                {/* Core Links */}
                <ul
                  className={`my-account-profile-details-item ${
                    user?.userId && 'mb-4'
                  }`}
                >
                  <li className="my-account-profile-details-list not-last:mb-3">
                    <Link
                      href="/user/profile"
                      className="my-account-profile-link gap-2 data-flex-item-center"
                      onClick={(e) => {
                        e.stopPropagation()
                        checkModal()
                        if (isMobile) {
                          document.body.style.overflow = 'auto'
                          closeAllMenus()
                        }
                      }}
                    >
                      <i className="m-icon profile-icon w-5! h-5!"></i>
                      <span>My Profile</span>
                    </Link>
                  </li>
                  {isloaded && user?.userId && (
                    <li className="my-account-profile-details-list not-last:mb-3">
                      <Link
                        href="/user/orders"
                        className="my-account-profile-link gap-2 data-flex-item-center"
                        onClick={(e) => {
                          e.stopPropagation()
                          checkModal()
                          if (isMobile) {
                            closeAllMenus()
                          }
                        }}
                      >
                        <i className="m-icon header_order_icon w-5! h-5!"></i>{' '}
                        <span>Orders</span>
                      </Link>
                    </li>
                  )}
                  <li className="my-account-profile-details-list not-last:mb-3">
                    <Link
                      href="/contact-us"
                      className="my-account-profile-link"
                      onClick={(e) => {
                        e.stopPropagation()
                        closeAllMenus()
                      }}
                    >
                      <i className="m-icon header_contact_icon w-5! h-5!"></i>
                      <span>Contact Us </span>
                    </Link>
                  </li>
                </ul>

                <hr className="border border-b w-full mb-4 border-[#DBDBDB]" />

                {/* Additional Links & Mobile-Specific Links */}
                <ul className="my-account-profile-details-item mb-4">
                  {isMobile && (
                    <>
                      <li className="my-account-profile-details-list not-last:mb-3">
                        <Link
                          href={'/user/review'}
                          className="my-account-profile-link gap-2 data-flex-item-center"
                          onClick={(e) => {
                            e.stopPropagation()
                            closeAllMenus()
                          }}
                        >
                          <i className="m-icon new-rating-empty-icon w-4 h-4 bg-black"></i>
                          <span>Review</span>
                        </Link>
                      </li>
                    </>
                  )}
                  <li className="my-account-profile-details-list not-last:mb-3">
                    <Link
                      href={isloaded && user?.userId ? '/user/coupon' : '#'}
                      className="my-account-profile-link gap-2 data-flex-item-center"
                      onClick={(e) => {
                        e.stopPropagation()
                        closeAllMenus()
                      }}
                    >
                      <i className="m-icon header_coupons_icon w-5! h-5!"></i>
                      <span>Coupons</span>
                    </Link>
                  </li>
                  <li className="my-account-profile-details-list not-last:mb-3">
                    <Link
                      href={isloaded && user?.userId ? '/user/address' : '#.'}
                      className="my-account-profile-link"
                      onClick={(e) => {
                        e.stopPropagation()
                        closeAllMenus()
                      }}
                    >
                      <i className="m-icon w-5! h-5! header_address_icon"></i>
                      <span>Saved Addresses</span>
                    </Link>
                  </li>
                </ul>

                <hr className="border border-b w-full mb-4 border-[#DBDBDB]" />

                {/* Logout Button */}
                <ul className="my-account-profile-details-item">
                  <li className="my-account-profile-details-list not-last:mb-3">
                    <button
                      onClick={(e) => {
                        e.stopPropagation()
                        handleUserLogout(e)
                      }}
                      className="my-account-profile-link w-full"
                    >
                      <i className="m-icon w-5! h-5! logout_icon"></i>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </li>

          {/* Mobile Overlay (tap outside to close) */}
          {isMobile && showMenubar && user?.userId && (
            <>
              <div
                className="fixed inset-0 bg-black/50 z-10"
                onClick={closeAllMenus}
              ></div>

              {/* Close Button */}
              <button
                className="fixed right-4 sm:right-15 max-md:top-14 max-sm:top-24 top-44 z-11 flex items-center justify-center p-1 active:bg-[#EAEAEF] sm:hover:bg-[#EAEAEF] rounded-sm"
                onClick={closeAllMenus}
              >
                <i className="m-icon close-icon"></i>
              </button>
            </>
          )}
        </ul>
      </div>
    </>
  )
}

export default MyAccount
